import { TypedDispatch, TypedThunk } from 'App/Store'
import { PLAYOFF_VS_LIST_ACTION } from 'core/constants/Actions'
import { getplayoffVsRounds } from 'core/services/Groups'

export function playoffVsRoundsList(params: any): TypedThunk {
  return async (dispatch: TypedDispatch): Promise<void> => {
    dispatch({ type: PLAYOFF_VS_LIST_ACTION.REQUEST })
    const apiResponse = await getplayoffVsRounds(params)
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: PLAYOFF_VS_LIST_ACTION.SUCCESS,
        payload: {
          rewarded: apiResponse.data.rewarded,
          tournamentCompleted: apiResponse.data.tournamentCompleted,
          winnerTeams: apiResponse.data.winnerTeams,
          prizeConfig: apiResponse.data.prizeConfig,
          tournamentDetails: apiResponse.data.tournamentDetails
        }
      })
    } else {
      dispatch({
        type: PLAYOFF_VS_LIST_ACTION.FAILURE
      })
    }
  }
}